/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { toast } from 'react-toastify';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
import { connect } from 'react-redux';

import { registerUser, receiveToken, doInit } from '../actions/auth';
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";

class Register extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      username: '',
      password: '',
      agree:false
    };

  }
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }
  
  onChange=(event)=> {
    this.setState({ [event.target.name]: event.target.value });
  }

  changeAgree=(event)=> {
    this.setState({ agree: event.target.value });
  }
  
  doRegister=(e)=>{
    e.preventDefault();
    // if(this.state.agree == false) {      
    //   // toast.error("Need to agree policy and terms");
    //   return;
    // }
    this.props.registerUser({ 
      company: this.state.company?this.state.company:"", 
      number: this.state.phone?this.state.phone:"", 
      firstname: this.state.firstname?this.state.firstname:"", 
      lastname: this.state.lastname?this.state.lastname:"", 
      email: this.state.email?this.state.email:"", 
      password: this.state.password ?this.state.password:""
    });
  }
  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <section className="section section-shaped section-lg">
            <div className="">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>
            <Container className="pt-lg-3">
              <Row className="justify-content-center">
                <Col lg="5">
                  <Card className="bg-secondary shadow border-0">
                    <CardBody className="px-lg-5 py-lg-5">
                      <div className="text-center text-muted mb-4">
                        Create a new account
                      </div>
                      <Form role="form" onSubmit={this.doRegister}>
                        <FormGroup>
                          <InputGroup className="input-group-alternative mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                              <i className="fa fa-building-o" aria-hidden="true"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Company Name" type="text" name="company"  value={this.state.company} onChange={this.onChange}/>
                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="input-group-alternative mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                              <i className="fa fa-phone" aria-hidden="true"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Contact Number" type="text" name="phone"  value={this.state.phone} onChange={this.onChange}/>
                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="input-group-alternative mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                              <i className="fa fa-user-circle-o" aria-hidden="true"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="First Name" type="text" name="firstname"  value={this.state.firstname} onChange={this.onChange}/>
                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="input-group-alternative mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                              <i className="fa fa-user-circle-o" aria-hidden="true"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Surname" type="text" name="lastname"  value={this.state.lastname} onChange={this.onChange}/>
                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="input-group-alternative mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-email-83" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Email" type="email" name="email"  value={this.state.email} onChange={this.onChange}/>
                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-lock-circle-open" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Password"
                              type="password"
                              autoComplete="off"
                              name="password"
                              value={this.state.password} onChange={this.onChange}
                            />
                          </InputGroup>
                        </FormGroup>
                        <div className="text-center">
                          <Button
                            className="mt-2"
                            color="primary"
                            type="submit"
                          >
                            Create account
                          </Button>
                          {
                            !this.props.auth.isFetching&&this.props.auth.errorMessage!=null&&
                            <p style={{color:'red', fontSize:'14px', marginTop:'5px'}}>{this.props.auth.errorMessage}</p>
                          }
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
            <LoadingOverlay
              active={this.props.auth.isFetching}
              styles={{
                  overlay: (base) => ({
                  ...base,
                  fontSize:'18px',
                  color: 'rgb(5, 37, 51)',
                  background: 'rgb(60 60 60 / 48%)',
                  position:'fixed',
                  zIndex:1000000000
                  })
              }}
              spinner = {<ScaleLoader color={'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
              // spinner
              // text='Loading ...'
              >
            </LoadingOverlay>
          </section>
        </main>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    registerUser: (company, number, firstname, lastname, email, password)=>dispatch(registerUser(company, number, firstname, lastname, email, password)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Register);
